import { Sparkles } from "lucide-react";

/**
 * Small, honest disclaimer shown near AI-generated study material.
 * AI output can be wrong — tell users to verify important facts.
 */
export default function AiDisclaimer({ className = "" }) {
  return (
    <p
      data-testid="ai-disclaimer"
      className={`flex items-start gap-1.5 text-[11.5px] text-[#8E8B99] leading-relaxed ${className}`}
    >
      <Sparkles size={12} className="text-[#B8A4FF] mt-0.5 shrink-0" />
      <span>AI-generated — may contain mistakes. Verify important facts before relying on them.</span>
    </p>
  );
}
